export default __webpack_public_path__ + "static/media/colab.617e3055.ico";